import React from "react";

import icon1 from "../../../assets/icons/1.png";
import icon2 from "../../../assets/icons/2.png";
import icon3 from "../../../assets/icons/3.png";
import icon4 from "../../../assets/icons/4.png";

import img1 from "../../../assets/images/img1.jpeg";

import './ThirdSector.css';

const ThirdSector = () => {
  return (
    <section className="iconos">
      <div className="imagen">
        <img src={img1} alt="Imagen" />
      </div>
      <div className="iconos-container">
        <div className="icono">
          <div className="icono-circulo">
            <img src={icon1} alt="Icono 1" />
          </div>
          <p>Amplia trayectoria en el sector inmobiliario de los Emiratos Árabes Unidos.</p>
        </div>
        <div className="icono">
          <div className="icono-circulo">
            <img src={icon2} alt="Icono 2" />
          </div>
          <p>Profesionales y expertos en su campo.</p>
        </div>
        <div className="icono">
          <div className="icono-circulo">
            <img src={icon3} alt="Icono 3" />
          </div>
          <p>Prioridad en el resguardo y revalorización de tus activos.</p>
        </div>
        <div className="icono">
          <div className="icono-circulo">
            <img src={icon4} alt="Icono 4" />
          </div>
          <p>Tratamiento exclusivo y proactivo para cada cliente.</p>
        </div>
      </div>
    </section>
  );
};

export default ThirdSector;